(function () {
  // === CONFIG: ajuste se precisar ===
  const selectors = [
    // Dawn >= v7 (main-collection-product-grid)
    '#ProductGridContainer .grid',
    // Fallback genérico:
    '.collection .grid, .template-collection .grid'
  ];
  const cardSelector = '.grid__item';          // wrapper de cada card
  const titleSelector = '.card__heading, [data-card-title]'; // seletor do título no card

  // Normaliza título -> "nome base"
  function baseName(raw) {
    if (!raw) return '';
    let t = raw.trim();

    // Se existir separador típico, pegue o prefixo (ajuste conforme sua convenção)
    // Ex.: "Camisa Deep Classic - Azul M" => "Camisa Deep Classic"
    const sepMatch = t.match(/^(.*?)(?:\s[-|–]\s| \| )/);
    if (sepMatch) t = sepMatch[1];

    // Remover sufixos comuns de variação entre parênteses: "(P)", "(GG)", "(Azul)"
    t = t.replace(/\s*\((?:[^)]+)\)\s*$/g, '');

    // Colocar em minúsculas e comprimir espaços
    t = t.toLowerCase().replace(/\s+/g, ' ').trim();
    return t;
  }

  // Ordenação estável por "nome base" mantendo ordem relativa original
  function sortNodesStable(nodes, keyExtractor) {
    return nodes
      .map((el, idx) => ({ el, idx, key: keyExtractor(el) }))
      .sort((a, b) => {
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        // mesma chave -> preserva ordem original
        return a.idx - b.idx;
      })
      .map(x => x.el);
  }

  function reorderGrid(grid) {
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll(cardSelector));
    if (!items.length) return;

    const ordered = sortNodesStable(items, (el) => {
      const titleEl = el.querySelector(titleSelector);
      const title = titleEl ? titleEl.textContent : '';
      return baseName(title);
    });

    // Reanexar na nova ordem
    const frag = document.createDocumentFragment();
    ordered.forEach(el => frag.appendChild(el));
    grid.appendChild(frag);
  }

  function run() {
    for (const sel of selectors) {
      document.querySelectorAll(sel).forEach(reorderGrid);
    }
  }

  // Rodar ao carregar e quando a seção recarregar (Shopify 2.0)
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:reorder', run);
})();